class AgeGateConsent extends HTMLElement {
  constructor() {
    super();
    this.countrySelect = this.querySelector('select#user_country');
    this.birthYearInput = this.querySelector('input#yearOfBirth');
    this.rememberMe = this.querySelector('#remember-me');
    this.submitButton = this.querySelector('#age-gate-button');
    this.failureLink = this.querySelector('#c-modal-popup__failure--link');
    this.currentYear = new Date().getFullYear();
  
    this.submitButton.addEventListener('click', this.onButtonClick.bind(this));
    this.countrySelect.addEventListener('change', this.validateNonEmptyForm.bind(this));
    this.birthYearInput.addEventListener('keyup', this.validateNonEmptyForm.bind(this));
    this.birthYearInput.addEventListener("keypress", this.onInputEnter.bind(this));
  
    this.isOpenNeeded();
  }
  
  isOpenNeeded() {
    if (sessionStorage.getItem("ageconsent") !== 'yes' && this.checkCookie('rememberageconsent') !== true) {
      this.open();
      return;
    }
    this.close();
  }
  
  execute() {
    if (this.isYearofBirthValid(this.birthYearInput.value)) {
      if (this.rememberMe.checked) {
        this.setCookie("rememberageconsent", "yes", 365);
      }
      sessionStorage.setItem('ageconsent', 'yes');
      // Set cookie to rember the show
      this.setCookie("rememberageconsent", "yes", window.age_gate_expired);
      this.close();
    } else {
      // alert(this.querySelector('#c-modal-popup__failure--message').innerText);
      // display error message
      var el = this.querySelector('.c-modal-popup__failure');
      if (el) {
        el.classList.remove('d-none');
      }
      if (this.failureLink && this.failureLink.innerText !== '') {
        window.location.href = this.failureLink.innerText;
      }
    }
  }
  
  validateNonEmptyForm() {
    if (this.countrySelect.value !== '' && this.birthYearInput !== null && this.birthYearInput.value !== '') {
      this.submitButton.removeAttribute('disabled');
    }
  }
  
  isYearofBirthValid(birth) {
    const minYear = this.currentYear - 130;
    let maxYear = this.currentYear - 21;
    if (this.countrySelect.value === 'AU' || this.countrySelect.value === 'NZ') {
      maxYear = this.currentYear - 18;
    }
    return (birth > minYear && birth <= maxYear);
  }
  
  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  
  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  checkCookie(cname) {
    return this.getCookie(cname) !== "";
  }
  
  onButtonClick(event) {
    event.preventDefault();
    this.execute();
  }
  
  onInputEnter(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.execute();
    }
  }

  open() {
    this.setAttribute('open', true);
    document.body.classList.add('age-gate-modal-open');

    trapFocus(
      this.querySelector('summary'),
      this.querySelector('input:not([type="hidden"])')
    );
  }

  close() {
    removeTrapFocus(null);
    this.removeAttribute('open');
    document.body.classList.remove('age-gate-modal-open');
    this.submitButton.removeEventListener('click', this.onButtonClick.bind(this));
    this.countrySelect.removeEventListener('change', this.validateNonEmptyForm.bind(this));
    this.birthYearInput.removeEventListener('change', this.validateNonEmptyForm.bind(this));
  }
}

customElements.define('age-gate-consent', AgeGateConsent);
